import { useState, useEffect } from 'react';
import { api } from '../api';
import { BRAND } from '../config/brand';

const G = BRAND.colors.primary;

export default function InvoicesPage({ dist, getToken, showToast }) {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [status, setStatus] = useState('all');

  useEffect(() => {
    loadInvoices();
  }, [status]);

  const loadInvoices = async () => {
    try {
      setLoading(true);
      setError(null);
      const token = await getToken();
      const result = await api.withToken(token).getInvoices(status === 'all' ? null : status);
      setInvoices(result?.invoices || []);
    } catch (err) {
      console.error('Failed to load invoices:', err);
      setError('Failed to load invoices');
      setInvoices([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '40px 24px', maxWidth: 1200, margin: '0 auto' }}>
      <div style={{ marginBottom: 32 }}>
        <div style={{ fontSize: 28, fontWeight: 700, color: '#0F172A', marginBottom: 8 }}>Invoices</div>
        <div style={{ fontSize: 14, color: '#64748B' }}>Manage and track invoice payments from clients</div>
      </div>

      <div style={{ display: 'flex', gap: 24, marginBottom: 24, borderBottom: `1px solid #E2E8F0`, paddingBottom: 16 }}>
        {['all', 'unpaid', 'paid'].map(s => (
          <button
            key={s}
            onClick={() => setStatus(s)}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              fontSize: 14,
              fontWeight: status === s ? 600 : 400,
              color: status === s ? G : '#64748B',
              cursor: 'pointer',
              borderBottom: status === s ? `2px solid ${G}` : 'none',
              paddingBottom: 8,
            }}
          >
            {s.charAt(0).toUpperCase() + s.slice(1)}
          </button>
        ))}
      </div>

      {loading && <div style={{ textAlign: 'center', color: '#94A3B8', padding: '40px 20px' }}>Loading invoices...</div>}
      {error && <div style={{ padding: 16, background: '#FEF2F2', color: '#991B1B', borderRadius: 8, marginBottom: 16 }}>{error}</div>}
      {!loading && !error && invoices.length === 0 && <div style={{ textAlign: 'center', color: '#94A3B8', padding: '40px 20px' }}>No invoices yet.</div>}
      {!loading && !error && invoices.length > 0 && (
        <div style={{ display: 'grid', gap: 12 }}>
          {invoices.map(inv => (
            <div key={inv.id} style={{ padding: 16, border: `1px solid #E2E8F0`, borderRadius: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ fontWeight: 600, marginBottom: 4 }}>Invoice {inv.invoice_number}</div>
                <div style={{ fontSize: 12, color: '#64748B' }}>{inv.client_name || inv.client_email || 'N/A'}</div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontWeight: 600, marginBottom: 4 }}>${parseFloat(inv.total || 0).toFixed(2)}</div>
                <div style={{ fontSize: 12, color: inv.payment_status === 'paid' ? '#10B981' : inv.payment_status === 'unpaid' ? '#F97316' : '#EF4444' }}>
                  {inv.payment_status.charAt(0).toUpperCase() + inv.payment_status.slice(1)}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
